import React from 'react';

import Skeleton from './Skeleton';

/**
 * @deprecated Use SkeletonContext in shared component library
 */
const withSkeleton = (getVisible) => (Component) => (props) => {
  const visible = getVisible(props);

  const SkeletonWithVisibleInjected = (skeletonProps) => (
    <Skeleton
      visible={visible}
      {...skeletonProps} // eslint-disable-line react/jsx-props-no-spreading
    />
  );

  return (
    <Component
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      Skeleton={SkeletonWithVisibleInjected}
    />
  );
};

export default withSkeleton;
